<script>
import Endpoints from '../../../../../components/common/Endpoints';
import Common from '../../../../../components/common/Common';
import Request from '../../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
    },
    methods:{
        selectItem: function(item){
            this.data = item; 
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
